import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

function extractRootDomain(url) {
  try {
    if (!url || typeof url !== "string") return url;

    let hostname = url.trim();

    if (hostname.includes("://")) {
      hostname = new URL(hostname).hostname;
    } else {
      hostname = hostname
        .split("/")[0]
        .split("?")[0]
        .split("#")[0]
        .split(":")[0];
    }

    if (!hostname) return url;

    hostname = hostname.replace(/^www\./, "");

    // Check if it's an IP address
    const ipRegex = /^\d+\.\d+\.\d+\.\d+$/;
    if (ipRegex.test(hostname)) {
      return hostname;
    }

    const parts = hostname.split(".").filter((part) => part.length > 0);

    if (parts.length >= 2) {
      // Handle common country code domains (co.uk, com.au, etc.)
      const lastPart = parts[parts.length - 1];
      const secondLastPart = parts[parts.length - 2];

      if (
        parts.length >= 3 &&
        (lastPart.length === 2 || // country codes like .uk, .au
          (lastPart === "uk" && secondLastPart === "co") ||
          (lastPart === "au" && secondLastPart === "com"))
      ) {
        return parts.slice(-3).join(".");
      }

      return parts.slice(-2).join(".");
    }

    return hostname;
  } catch (error) {
    console.error("Error extracting root domain:", error);
    return url;
  }
}

function useJdPowerScript(jdPowerToken) {
  const [domain, setDomain] = useState("");
  const location = useLocation();

  useEffect(() => {
    let params = new URLSearchParams(location.search);
    let urlValue = params.get("url");

    if (urlValue) {
      const rootDomain = extractRootDomain(urlValue);
      setDomain(rootDomain);
    }
  }, [location.search]);

  useEffect(() => {
    if (!jdPowerToken || !domain) return;

    if (
      !document.querySelector(
        'script[src*="https://scripts.orb.ee/tms.js?sid="]',
      )
    ) {
      (function (w, d, n, o, g, namespace) {
        w.orbObject = w.orbObject || n;
        if (!w[n]) {
          w[n] = function () {
            return (w[n].q = w[n].q || []).push(arguments);
          };
          w[n].q = w[n].q || [];
        }
        var s = d.createElement(o),
          m = d.getElementsByTagName(o)[0];
        s.async = 1;
        s.src = g + "%3A" + namespace;
        m.parentNode.insertBefore(s, m);
      })(
        window,
        document,
        "orb",
        "script",
        `https://scripts.orb.ee/tms.js?sid=${jdPowerToken}`,
        domain,
      );
    }
  }, [jdPowerToken, domain]);
}

export default useJdPowerScript;
